import { useSelector, useDispatch } from "react-redux";
import { clear_error_boundary } from "../../App/actions/errorBoundaryActions";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useEffect, useState } from "react";

// image
import error_triangle_icon from "../../Assets/svg/error_triangle_icon.svg";
import mapid_error_graphic from "../..//Assets/png_jpg/mapid_error_graphic.png";

// Data
import dict from "../../Data/dict.json";

function ErrorUIBoundary() {
  const language = localStorage?.language || "ina";
  const history = useHistory();
  const error_boundary = useSelector((state) => state.error_boundary);
  const dispatch = useDispatch();
  const prevPathname = useSelector((state) => state.auth.previous_pathname);
  const [frozenPrevPath, setFrozenPrevPath] = useState(null);
  const [isDetailErrorModal, setIsDetailErrorModal] = useState(false);

  const onRedirect = () => {
    dispatch(clear_error_boundary());
    if (frozenPrevPath) {
      history.push(frozenPrevPath); // Menggunakan frozenPrevPath untuk menghindari infinite loop dengan kembali ke halaman sebelumnya
      // history.push("/"); // Menggunakan "/" untuk menghindari infinite loop dengan kembali ke halaman home
    }
  };

  const onClickErrorDetailModal = () => {
    if (isDetailErrorModal) {
      setIsDetailErrorModal(false);
    } else {
      setIsDetailErrorModal(true);
    }
  };

  useEffect(() => {
    if (Object.keys(error_boundary).length > 0 && !frozenPrevPath) {
      setFrozenPrevPath(prevPathname);
    }
  }, [error_boundary, prevPathname, frozenPrevPath]);

  const isEmpty = Object.keys(error_boundary).length;
  if (isEmpty === 0) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000, // Pastikan di atas elemen lain
      }}
    >
      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: ".5rem",
        }}
      >
        <img
          src={error_triangle_icon}
          alt="error sign"
          width={"40rem"}
          style={{ marginBottom: "1rem" }}
        />
        <img
          src={mapid_error_graphic}
          alt="error boundary"
          width={"350rem"}
          style={{ marginBottom: "1rem" }}
        />
        {isDetailErrorModal ? (
          <ErrorDetailModal
            name={error_boundary?.message?.name}
            message={error_boundary?.message?.message}
            stack={error_boundary?.message?.stack}
          ></ErrorDetailModal>
        ) : (
          <>
            <h1>{dict?.["Something went wrong"]?.[language]}</h1>
            <p style={{ width: "19rem", textAlign: "center", display: "flex" }}>
              {
                dict?.[
                  "Brace yourself till we get the error fixed. You can go back to previous page."
                ]?.[language]
              }
            </p>
          </>
        )}
        {/* <p>{error_boundary?.message?.message}</p> */}
        <button className="button background_red" onClick={onRedirect}>
          {dict?.["Back"]?.[language]}
        </button>
        <button
          className="button background_black"
          onClick={() => onClickErrorDetailModal()}
        >
          Detail Error
        </button>
      </div>
    </div>
  );
}

function ErrorDetailModal(props) {
  const { name, message, stack } = props;
  const errorString = "Error: ";
  const avoidStringLength = message?.length + errorString?.length;
  const newStack = stack?.slice(avoidStringLength);
  const stackArray = newStack?.split(" at ");
  stackArray?.shift();

  return (
    <>
      <div
        className="container_notification"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: ".3rem",
          // position: "fixed",
          maxWidth: "30rem",
          height: "10rem",
          padding: "1rem",
          overflowY: "scroll",
          scrollbarWidth: "thin",
          // top: 0,
          // right: "50%",
          // transform: "translateX(50%)",
          zIndex: 1500,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: ".5rem",
            justifyContent: "start",
            alignItems: "start",
          }}
        >
          <p style={{ fontSize: "1.5rem", fontWeight: "bold" }}>{name}</p>
          <p style={{ textAlign: "left", fontSize: ".9rem" }}>{message}</p>
          {stackArray?.map((text, index) => (
            <p
              key={index}
              style={{
                textAlign: "left",
                lineHeight: 2,
                paddingLeft: "2rem",
                fontSize: ".7rem",
              }}
              className="text_grey"
            >
              at {text}
            </p>
          ))}
        </div>
      </div>
    </>
  );
}

export default ErrorUIBoundary;
